"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const utils_1 = require("@8base-react/utils");
const PermissionsContext_1 = require("./PermissionsContext");
const withPermissions = (WrappedComponent) => { var _a; return _a = class WithPermissions extends react_1.default.Component {
        render() {
            return (react_1.default.createElement(PermissionsContext_1.PermissionsContext.Consumer, null, ({ permissions }) => react_1.default.createElement(WrappedComponent, Object.assign({}, this.props, { permissions: permissions }))));
        }
    },
    _a.displayName = `withPermissions(${utils_1.getDisplayName(WrappedComponent)})`,
    _a; };
exports.withPermissions = withPermissions;
//# sourceMappingURL=withPermissions.js.map